import { render, staticRenderFns } from "./UserModal.vue?vue&type=template&id=044d234f&scoped=true"
import script from "./UserModal.vue?vue&type=script&lang=js"
export * from "./UserModal.vue?vue&type=script&lang=js"
import "./UserModal.vue?vue&type=style&index=0&id=044d234f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044d234f",
  null
  
)

export default component.exports